import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import {User} from "../models";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import { locale as polish } from './i18n/pl';
import {SellingReportService} from "./service/sellingReport.service";
import {SellingReport} from "../models/sellingReport";
import {first} from "rxjs/operators";
import {VoucherTemplate} from "../models/voucherTemplate";
import {fuseAnimations} from "../../../@fuse/animations";
import {ProductService} from "../services/product.service";
import {Product} from "../models/product";
import {VoucherTemplateService} from "../services/voucherTemplate.service";
import {SellingReportList} from "../models/sellingReportList";
import {TopSellerList} from "../models/topSellerList";
import {TopSeller} from "../models/topSeller";
import {FormControl, FormGroup} from "@angular/forms";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {CardMetricsService} from "./service/cardMetricsService";
import {CardMetricsList} from "../models/cardMetricsList";
import {CardMetrics} from "../models/cardMetrics";

export const MY_FORMATS = {
    parse: {
        dateInput: 'DD.MM.YYYY',
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM-YYYY',
    },
};

@Component({
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations,
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },

        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})
export class ReportComponent implements OnDestroy, OnInit {
    rows: SellingReport[];
    topProducts: TopSeller[] = [];
    topVouchers: TopSeller[] = [];
    topSellersData: TopSeller[];
    topSellersSummaryData: TopSeller[];
    paymentMethodsSummaryData: SellingReportList;
    visitorsSummaryData: CardMetrics[];
    loadingIndicator: boolean;
    reorderable: boolean;
    totalValue: number = 0;
    totalQuantity: number = 0;
    dateRange: FormGroup;
    fastDate: string = 'lastWeek';
    chartColors: any[] = [
        {
            borderColor    : '#42a5f5',
            backgroundColor: '#42a5f5'
        }
    ];
    totalValueChart = {
        chartType: 'bar',
        labels: [],
        datasets: [
            {
                label: 'Value',
                data: []
            }
        ],
        options: {
            spanGaps           : false,
            legend             : {
                display: false
            },
            maintainAspectRatio: false,
            layout             : {
                padding: {
                    top   : 24,
                    left  : 16,
                    right : 16,
                    bottom: 16
                }
            },
            scales             : {
                xAxes: [
                    {
                        display: false
                    }
                ],
                yAxes: [
                    {
                        display: false,
                        ticks  : {
                            beginAtZero: true
                        }
                    }
                ]
            }
        }
    };

    totalQuantityChart = {
        chartColor: [
            {
                borderColor    : '#f44336',
                backgroundColor: '#f44336'
            }
        ],
        chartType: 'bar',
        labels: [],
        datasets: [
            {
                label: 'Quantity',
                data: []
            }
        ],
        options: {
            spanGaps           : false,
            legend             : {
                display: false
            },
            maintainAspectRatio: false,
            layout             : {
                padding: {
                    top   : 24,
                    left  : 16,
                    right : 16,
                    bottom: 16
                }
            },
            scales             : {
                xAxes: [
                    {
                        display: false
                    }
                ],
                yAxes: [
                    {
                        display: false,
                        ticks  : {
                            beginAtZero: true
                        }
                    }
                ]
            }
        }
    };

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private sellingReportService: SellingReportService,
        private productService: ProductService,
        private voucherTemplateService: VoucherTemplateService,
        private cardMetricsService: CardMetricsService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Reports');

        let today = new Date();

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    ngOnInit() {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.updateReportData(start, end);
        this.topSellingProducts(start, end);
        this.topSellingVouchers(start, end);
        this.topSellers(start, end);
        this.topSellersSummary(start, end);
        this.paymentMethodsSummary(start, end);
        this.visitorsSummary(start, end);
    }

    ngOnDestroy(): void {

    }

    today() {
        this.fastDate = 'today';
        let start = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date()),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, start);
        this.topSellers(start, start);
        this.topSellersSummary(start, start);
        this.topSellingProducts(start, start);
        this.topSellingVouchers(start, start);
        this.paymentMethodsSummary(start, start);
        this.visitorsSummary(start, start);
    }

    yesterday() {
        this.fastDate = 'yesterday';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-1)));

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-1))),
            end: new FormControl(new Date(today.setDate(today.getDate()-1))),
        });

        this.updateReportData(start, start);
        this.topSellers(start, start);
        this.topSellersSummary(start, start);
        this.topSellingProducts(start, start);
        this.topSellingVouchers(start, start);
        this.paymentMethodsSummary(start, start);
        this.visitorsSummary(start, start);
    }

    lastWeek() {
        this.fastDate = 'lastWeek';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
        this.topSellers(start, end);
        this.topSellersSummary(start, end);
        this.topSellingProducts(start, end);
        this.topSellingVouchers(start, end);
        this.paymentMethodsSummary(start, end);
        this.visitorsSummary(start, end);
    }

    lastMonth() {
        this.fastDate = 'lastMonth';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
        this.topSellers(start, end);
        this.topSellersSummary(start, end);
        this.topSellingProducts(start, end);
        this.topSellingVouchers(start, end);
        this.paymentMethodsSummary(start, end);
        this.visitorsSummary(start, end);
    }

    reloadStats(event: MatDatepickerInputEvent<any>) {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReportData(start, end);
        this.topSellers(start, end);
        this.topSellersSummary(start, end);
        this.topSellingProducts(start, end);
        this.topSellingVouchers(start, end);
        this.paymentMethodsSummary(start, end);
        this.visitorsSummary(start, end);
    }

    updateReportData(createdAt: string, createdAtTo: string): void {
        this.sellingReportService.get(createdAt, createdAtTo).pipe(first()).subscribe((res: SellingReportList) => {
            this.rows = res.items;
            let days = [];

            let minV = 9999999;
            let maxV = 0;
            let minQ = 9999999;
            let maxQ = 0;

            this.totalValue = 0;
            this.totalQuantity = 0;

            this.totalValueChart.datasets[0].data = [];
            this.totalQuantityChart.datasets[0].data = [];
            this.totalValueChart.labels = [];
            this.totalQuantityChart.labels = [];

            for (let i=0; i<res.items.length; i++) {
                console.log(res.items[i].grossValue);
                this.totalValue += res.items[i].grossValue;
                console.log('Total value: ' + this.totalValue);
                this.totalQuantity += res.items[i].quantity;

                let day = res.items[i].createdAt.substring(0, 10);

                if (!this.totalValueChart.labels.includes(day)) {
                    this.totalValueChart.labels.push(day);
                    this.totalQuantityChart.labels.push(day);
                    days.push({date: day, value: 0, quantity: 0});
                }

                days.forEach(function(item, index) {
                    if (item.date===day) {
                        item.value += res.items[i].grossValue;
                        item.quantity += res.items[i].quantity;
                    }
                });
            }

            let d = [];
            let dq = [];

            function valueXFunction(item, index, arr) {
                d.push(item.value);
                dq.push(item.quantity);

                if (item.value>maxV) {
                    maxV = item.value;
                }

                if (item.value<minV) {
                    minV = item.value;
                }

                if (item.quantity>maxQ) {
                    maxQ = item.quantity;
                }

                if (item.quantity<minQ) {
                    minQ = item.quantity;
                }
            }

            days.forEach(valueXFunction);

            this.totalValueChart.datasets[0].data.push(...d);
            this.totalQuantityChart.datasets[0].data.push(...dq);
        });
    }

    topSellingProducts(createdAt: string, createdAtTo: string): void {
        this.topProducts = [];
        this.sellingReportService.getTopProducts(createdAt, createdAtTo).pipe(first()).subscribe((res: TopSellerList) => {
            this.topProducts = res.items;
        });
    }

    topSellingVouchers(createdAt: string, createdAtTo: string): void {
        this.topVouchers= [];
        this.sellingReportService.getTopVouchers(createdAt, createdAtTo).pipe(first()).subscribe((res: TopSellerList) => {
            this.topVouchers = res.items;
        });
    }

    topSellers(createdAt: string, createdAtTo: string): void {
        this.topSellersData = [];
        this.sellingReportService.getTopSellersByDay(createdAt, createdAtTo).pipe(first()).subscribe((res: TopSellerList) => {
            this.topSellersData = res.items;
        });
    }

    topSellersSummary(createdAt: string, createdAtTo: string): void {
        this.topSellersSummaryData = [];
        this.sellingReportService.getTopSellersSummary(createdAt, createdAtTo).pipe(first()).subscribe((res: TopSellerList) => {
            this.topSellersSummaryData = res.items;
        });
    }

    visitorsSummary(createdAt: string, createdAtTo: string): void {
        this.visitorsSummaryData = [];
        this.cardMetricsService.get(createdAt, createdAtTo).pipe(first()).subscribe((res: CardMetricsList) => {
            this.visitorsSummaryData = res.items;
        });
    }

    paymentMethodsSummary(createdAt: string, createdAtTo: string): void {
        this.topSellersSummaryData = [];
        this.sellingReportService.getPaymentMethodsSummary(createdAt, createdAtTo).pipe(first()).subscribe((res: SellingReportList) => {
            this.paymentMethodsSummaryData = res;
        });
    }
}
